module.exports = __webpack_public_path__ + "img/Fiche chargé d'intégration.e6752393.jpg";